module.exports = __webpack_public_path__ + "assets/icon-result-component.5c94cd47.svg";